import { useQuery } from '@tanstack/react-query';

import { callService } from '@api/caller';

/**
 * Find hotel location by slug
 * @param hotelSlug string
 * @returns UseQueryResult<SearchViewModel[]>
 */
export const useFindHotelLocationBySlug = (hotelSlug = '', enabled = true) => {
  const isLongEnough: boolean = hotelSlug?.length >= 3;

  return useQuery({
    queryKey: ['hotel-location-search', hotelSlug],
    queryFn: async () => {
      return await callService('SearchesService', 'searchesUrl', {
        s: hotelSlug,
        webUrl: 'Hotel',
      });
    },
    enabled: isLongEnough && enabled,
  });
};
